module.exports = __webpack_public_path__ + "static/media/interest.a4ca3dee.svg";